export default __webpack_public_path__ + "static/media/cinema.088f4b4e.png";